<template>
  <div class="ho" :class="{ 'ho-bar': bar }">
    <span v-if="!o || o === 'running'" class="ho-run">reading the odds…</span>
    <template v-else>
      <span class="ho-word"><b :style="{ color: o.favBright }">{{ o.fav }}</b> {{ o.word.toLowerCase() }}</span>
      <span v-if="bar" class="ho-meter" v-tip="`calibrated ${pctL}% / ${100 - pctL}% (raw sim ${o.rawL}% over ${o.n} battles)`">
        <span class="ho-l" :style="{ width: pctL + '%', background: hero.l.bright }">{{ pctL }}%</span>
        <span class="ho-r" :style="{ width: (100 - pctL) + '%', background: hero.r.bright }">{{ 100 - pctL }}%</span>
      </span>
    </template>
  </div>
</template>

<script>
// The spotlight's worded odds: just the label, no numbers, not even on hover (Justin, 2026-10-24: front and center on
// the homepage it stays a little vague; the Battle lab and the team card have the numbers). With `bar` (the team card)
// a two-color meter of the calibrated chances, raw sim % on hover.
export default {
  name: 'HeroOdds',
  props: { o: { type: [Object, String], default: null }, hero: { type: Object, required: true }, bar: { type: Boolean, default: false } },
  computed: { pctL() { return Math.round(100 * this.o.pA); } },
};
</script>

<style scoped>
.ho { display: flex; flex-direction: column; align-items: center; gap: 4px; }
.ho-run { font-style: italic; color: var(--mute); font-size: 14px; }
.ho-word { font-family: var(--cond); font-weight: 600; font-size: 24px; letter-spacing: .4px; color: #f3ecd8; text-shadow: 0 1px 0 #000; }
.ho-word b { font-weight: 700; }
.ho-bar { align-items: stretch; }
.ho-meter { display: flex; height: 22px; border-radius: 3px; overflow: hidden; border: 1px solid rgba(217,180,94,.5); }
.ho-l, .ho-r { display: flex; align-items: center; font-family: var(--cond); font-weight: 700; font-size: 13px; color: #fff; text-shadow: 0 1px 0 rgba(0,0,0,.6); min-width: 34px; }
.ho-l { padding-left: 8px; } .ho-r { justify-content: flex-end; padding-right: 8px; }
</style>
